import * as yup from "yup";

export const schema = yup.object().shape({
  status: yup.string().required("Status is required field"),
});


export const getRadioButtonData = (status) => [
  {
    label: "Status",
    value: status,
    onChangeField: "status",
  },
];

export const getButtonData = (onFinish, onCancel, hasError, isTouched) => [
  {
    name: "Update",
    onClick: onFinish,
    variant: "contained",
    type: "primary",
    disabled: hasError(),
  },
  {
    name: "Close",
    onClick: onCancel,
    variant: "outlined",
    type: "primary",
    disabled: false,
  },
];

export const getButtonDataApproved = (onFinishApproved) => [
  {
    name: "Approve",
    onClick: onFinishApproved,
    variant: "contained",
    type: "primary",
    disabled: false
  },
];

export const getButtonDataCancel = (onCancel) => [
  {
    name: "Cancel",
    onClick: onCancel,
    variant: "outlined",
    type: "primary",
    disabled: false
  },
];

export const getTextfieldDataMessage = (message) => [
  {
    label: "Message",
    value: message,
    onChangeField: "message",
  },
];

export const getButtonDataSendMessage = (onFinishMessage) => [
  {
    name: "Send Message",
    onClick: onFinishMessage,
    variant: "contained",
    type: "primary",
    disabled: false
  },
];
